<template>
<!--分学银行-->
  <div class="content">
    <headers></headers>
    <div class="nav">
      <div class="auto">行业证书  >  操作指南  >  证书信息登记  >  工作经历 </div>
    </div>
    <div class="auto padding250">
       <p class="title">工作经历</p>
      <div class="container ">
        <img src="../../assets/step2.png" alt="" style="display: none;">
        <img src="../../assets/step33.png" alt="">
        <div class="formWrapper">
          <Form :label-width="80" label-position="right" class="formMin" >
            <FormItem label="行业类型  " class="txt-left">
                        <Select placeholder="请选择行业类型">
                            <Option value="">男</Option>
                            <Option value="">女</Option>

                        </Select>
                    </FormItem>
              <FormItem label="工作单位   ">
                <Input  value="" placeholder="请输入工作单位 " />
              </FormItem>

                      <FormItem label="企业类型   " class="txt-left">
                                  <Select placeholder="请选择企业类型  ">
                                      <Option value="">男</Option>
                                      <Option value="">女</Option>

                                  </Select>
                              </FormItem>
                              <FormItem label="部门 ">
                                <Input  value="" placeholder="请选输入部门 " />
                              </FormItem>
                              <FormItem label="职位/岗位  ">
                                <Input  value="" placeholder="请选输入职位 " />
                              </FormItem>
              <FormItem label="工作时间   " >
                <DatePicker class="dateRight" value="2018-09-06"  type="date" placeholder="请选择工作时间 * " style="width: 248px"></DatePicker>
              </FormItem>
            <FormItem label=" " class="txt-left">
              <div class="keepThis"><router-link  to="/step3" class="keepBtn" style="display: none;">下一步</router-link></div>
              <div class="keepThis"><router-link  to="/step4" class="keepBtn">下一步</router-link></div>
            </FormItem>
          </Form>

        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .formWrapper{
    width: 420px;
    padding: 40px 0 0 90px;
  }
  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .content{
    background-color: #f5f5f5;
    text-align: left;
    .title{
      font-size: 26px;
      color: #000;
      margin-top: 30px;
    }
    .container{
      background-color: #fff;
      padding: 50px 30px;
      margin-top: 10px;
      text-align: center;

      a{
        color: #fff;
        display: inline-block;
        width: 220px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 5px;
        font-size: 16px;
        background-color: #073C68;
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'

    export default {
        name: 'fenxue',
        props: {},
        data() {
            return {};
        },
        methods: {},
        created() {

        },
        components: {
          headers,
          footers

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/changeScore/step2.vue